import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sidenav, Nav, Dropdown } from "rsuite";
import {
  FaHome,
  FaUserCog,
  FaUserAlt,
  FaCog,
  FaQuestionCircle,
  FaRegEdit,
  FaRegListAlt,
  FaVideo,
} from "react-icons/fa";
import Helper from "../../../Helper";
import HttpRequest from '../../../Libraries/HttpRequest/HttpRequest';
import api from "../../../Api";

function Sidebar() {

  let authUser = Helper.getStorageData('session');

  const [image_path, set_image_path] = useState([]);
  // const [modules, setModules] = useState([]);
  const location = useLocation()
  const navigate = useNavigate()

  const routes = [
    // { path: '/dashboard', key: '1', title: 'Dashboard', icon: <FaHome /> },
    { path: '/users', key: '2', title: 'User', icon: <FaUserAlt /> },
    { path: '/reported-users', key: '4', title: 'Reported User', icon: <FaUserAlt /> },
  ]

  useEffect(() => {
    if(authUser?.image_path){
      set_image_path(Helper.generateImageURL(authUser?.image_path))
    }
    else{
      set_image_path('/images/placeholder.jpg')
    }
  }, [])

  // useEffect(() => {
  //   checkAuth()
  // }, [location])

  // function checkAuth(){
  //   if(!authUser) navigate('/login/zekkmdvhkm')
  // }

  return (
    <>
      <div className="main-sidebar-nav default-navigation">
        <div className="nano">
          <div className="nano-content sidebar-nav">
            <div className="card-body border-bottom text-center nav-profile">
              <div className="notify setpos">
                <span className="heartbit"></span>
                <span className="point"></span>
              </div>
              <img
                alt="profile"
                className="margin-b-10"
                src={image_path}
                width="80"
              />
              <p className="lead margin-b-0 toggle-none">{authUser?.full_name || 'Admin'}</p>
              <p className="text-muted mv-0 toggle-none">Welcome</p>
            </div>
            <div className="mt-5" style={{ width: 240 }}>
              <Sidenav>
                <Sidenav.Body>
                  <Nav activeKey={location.pathname}>
                    {
                      routes.map(item => (
                        <Nav.Item as={Link} eventKey={item.path} to={item.path} icon={item.icon}>
                          {item.title}
                        </Nav.Item>
                      ))
                    }
                  </Nav>
                </Sidenav.Body>
              </Sidenav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default React.memo(Sidebar)
